import { useMemo } from "react";
import PropTypes from "prop-types";

import { alignItems } from "../../consts";
import { t } from "../../services";

import { FlexContainers, Paragraph2, WrapperContainer } from "..";
import { ColorIndicator, LabelInfo, LabelsInfoWrapper } from "./styled";

const ChartLabelsInfoTooltip = ({ metricsConfig, lablesInfoConfig }) => {
  const metricKeys = useMemo(() => {
    return Object.keys(metricsConfig);
  }, [metricsConfig]);

  return metricKeys?.length ? (
    <LabelsInfoWrapper
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      maxWidth={390}
      pv={8}
      gap={8}>
      {metricKeys.map((metric) => {
        const metricConfig = metricsConfig[metric];
        const metricInfo = lablesInfoConfig[metric];

        return (
          <LabelInfo key={metric} Container={FlexContainers.FlexRowStart} gap={8}>
            <ColorIndicator color={metricConfig?.color} />
            <WrapperContainer Container={FlexContainers.FlexRowStart} alignItems={alignItems.start}>
              <Paragraph2>
                {`${t(metricConfig?.name)}: `}
                <span>{t(metricInfo)}</span>
              </Paragraph2>
            </WrapperContainer>
          </LabelInfo>
        );
      })}
    </LabelsInfoWrapper>
  ) : null;
};

ChartLabelsInfoTooltip.propTypes = {
  metricsConfig: PropTypes.shape(PropTypes.object).isRequired,
  lablesInfoConfig: PropTypes.shape(PropTypes.object).isRequired
};

export default ChartLabelsInfoTooltip;
